// extracted by mini-css-extract-plugin
export var sliderRange = "_nk-2";
export var sliderRoot = "_nk-0";
export var sliderThumb = "_nk-3";
export var sliderTrack = "_nk-1";